import MediaLayout from '@/features/messages/components/media-layout/media-layout';
import { useMemo } from 'react';
import { AttachmentType } from '../../models/attachment';
import type { Message } from '../../models/message';
import { MessageLayout } from '../message-layout/message-layout';
import { ComposeAudio } from './compose-audio';
import { ComposeFiles } from './compose-files';
import { ComposeLink } from './compose-link';
import { TextWithLinks } from './text-with-links';

interface MessageComposeProps {
  message: Message;
  isCurUser?: boolean;
  mode?: 'compact' | 'comfortable';
  isLast?: boolean;
}

export default function MessageCompose({ message, isCurUser = false, mode, isLast }: MessageComposeProps) {
  const { mediaAttachments, fileAttachments, linkAttachment, audioAttachment } = useMemo(() => {
    const attachments = message.structuredAttachments || [];
    return {
      mediaAttachments: attachments.filter((f) => f.contentType === AttachmentType.MEDIA),
      fileAttachments: attachments.filter((f) => f.contentType === AttachmentType.FILE),
      linkAttachment: attachments.find((f) => f.contentType === AttachmentType.LINK),
      audioAttachment: attachments.find((f) => f.contentType === AttachmentType.AUDIO)
    };
  }, [message.structuredAttachments]);

  return (
    <MessageLayout
      className='mex:!p-0 mex:!border-none mex:!shadow-none mex:!rounded-lg '
      isOwn={isCurUser}
      senderId={message.senderId}
      sentAt={message.sentAt}
      message={message}
      mode={mode}
      isLast={isLast}
    >
      <MediaLayout attachments={mediaAttachments as any} />
      <ComposeFiles mode={mode} attachments={fileAttachments || []} />
      {message.content && (
        <div className='mex:p-2'>
          <TextWithLinks text={message.content} variant='inherit' className='mex:text-[15px]' />
        </div>
      )}
      {audioAttachment && <ComposeAudio isOwner={isCurUser} mode={mode} attachment={audioAttachment as any} />}
      {linkAttachment && <ComposeLink isOwner={isCurUser} mode={mode} attachment={linkAttachment as any} />}
    </MessageLayout>
  );
}
